import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input, OnChanges,
    OnInit,
    Output, QueryList, SimpleChanges,
    ViewChild, ViewChildren
} from '@angular/core';

@Component({
    selector: 'app-image-slider-smart-tv',
    templateUrl: './image-slider-smart-tv.component.html',
    styleUrls: ['./image-slider-smart-tv.component.scss']
})
export class ImageSliderSmartTvComponent implements OnInit, AfterViewInit {

    @ViewChild('imageSlider') containerRef: ElementRef;
    @ViewChildren('thumbs') thumbs: QueryList<any>;

    @Input() type: string;
    @Input() thumbnailType: string;
    @Input() items: any[];
    @Input() displayItems: any[] = [];
    @Input() currentFocus = false;
    @Input() isShowsPage: boolean = false;
	@Input() isContinueWatching: boolean = false;
    @Input() rowIndex: number;
    @Input() rowFocusIndex: number;
    @Input() recommendationId: string

    @Output() rowFocused = new EventEmitter<void>();

    numberOfItems: number = 5;
    width: number;
    taken: number = 0;
    focusedIndex = 0;

    constructor(private cdr: ChangeDetectorRef) {
        cdr.detach();
    }

    ngOnInit(): void {
    }

    ngAfterViewInit() {
        this.cdr.detectChanges();
        this.calculateSliderSize();
        this.cdr.detectChanges();
        this.cdr.reattach();
    }

    onResize(event) {
        this.calculateSliderSize();
    }

    private calculateSliderSize() {
        let width = this.containerRef.nativeElement.getBoundingClientRect().width;

        if ((this.type == 'thumbs' || this.type == 'media-list' || this.type == 'show-list' || this.type === 'season-banner') && this.thumbnailType !== 'large') {
            if (width > 2000) {
                this.numberOfItems = 6;
            } else if (width > 1400) {
                this.numberOfItems = 5;
            } else if (width > 900) {
                this.numberOfItems = 4;
            } else if (width > 600) {
                this.numberOfItems = 3;
            } else {
                this.numberOfItems = 2;
            }
        } else if (this.type == 'media-list-channel' || this.thumbnailType === 'large') {
            if (width > 2000) {
                this.numberOfItems = 3;
            } else if (width > 1400) {
                this.numberOfItems = 3;
            } else if (width > 900) {
                this.numberOfItems = 3;
            } else if (width > 600) {
                this.numberOfItems = 2;
            } else {
                this.numberOfItems = 2;
            }
        } else if (this.type == 'media-list-double') {
            if (width > 2000) {
                this.numberOfItems = 6;
            } else if (width > 1400) {
                this.numberOfItems = 6;
            } else if (width > 900) {
                this.numberOfItems = 6;
            } else if (width > 600) {
                this.numberOfItems = 4;
            } else {
                this.numberOfItems = 2;
            }
        } else if (this.type == 'media-list-greenlight') {
            if (width > 1600) {
                this.numberOfItems = 5;
            } else if (width > 1200) {
                this.numberOfItems = 4;
            } else if (width > 900) {
                this.numberOfItems = 3;
            } else if (width > 600) {
                this.numberOfItems = 2;
            } else {
                this.numberOfItems = 1;
            }
        }

        this.width = 100 / this.numberOfItems;
        this.fillDisplayItems();
    }

    fillDisplayItems() {
        if (this.taken < this.numberOfItems * 2) {
            this.takeMoreItems(this.numberOfItems * 2);
        }

        setTimeout(() => {
            if (this.currentFocus) {
                this.thumbs.toArray()[0].thumb.nativeElement.focus();
            }

        }, 100)
    }

    private takeMoreItems(amount: number) {
        if (this.items) {
            let take = this.taken + amount;
            let nextItems = this.items.slice(this.taken, take);
            this.displayItems = this.displayItems.concat(nextItems);
            this.taken += amount;

            if (this.displayItems.length === this.items.length) {
                const len = this.numberOfItems - 1;
                const arr = new Array(len).fill(undefined);
                this.displayItems = this.displayItems.concat(arr);
            }
        }
    }

    thumbFocused(i: number) {
        this.focusedIndex = i;
        this.rowFocused.emit();
        if (i >= (this.taken - this.numberOfItems)) {
            this.takeMoreItems(this.numberOfItems);
        }
    }
}
